import { render, staticRenderFns } from "./BulkClaimConfirmationDialog.vue?vue&type=template&id=c23616d6&scoped=true&lang=pug&"
import script from "./BulkClaimConfirmationDialog.vue?vue&type=script&lang=js&"
export * from "./BulkClaimConfirmationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c23616d6",
  null
  
)

export default component.exports